<template>
  <div>
    <el-dialog :title="'（' + workerInfo.workerName + '）接单区域'" :visible.sync="areaVisible" width="900px" center
      :close-on-click-modal="false">
      <el-row> 
          <el-select v-model="levelOneName" clearable multiple  placeholder="请选加载地图区域" filterable>
            <el-option
              v-for="(item,index) in countyList"
              :key="index"
              :label="item"
              :value="item" 
            ></el-option>
          </el-select> 
          <el-button type="primary" @click="getCityArea()">加载地图区域</el-button>
      </el-row>

      <el-form ref="workerAreaForm" :rules="areaRules" :model="workerAreaForm" style="display: flex;"> 
       
        <el-form-item label="接单区域" prop="area" >
          <el-select v-model="workerAreaForm.area" clearable placeholder="请选择接单区域" filterable multiple
            @change="areaChange">
            <el-option v-for="(item, index) in areaList" :key="index"
              :label="item.areaName + '（' + item.distanceMetre + 'km）'" :value="item.id"></el-option>
          </el-select>
          <el-checkbox v-model="showType" style="margin-left:50px" @change="showTypeChange">仅显示关联区域</el-checkbox>
        </el-form-item>   
      </el-form>

    
      <el-row> <span>服务者位置：{{ workerInfo.servicePosition }} </span> </el-row>

      <p style="margin:20px 0 10px;color:red;">
        提示：1、以下列表区域排在最上面优先接单，2、服务区域距离，以服务区域中心点到服务者位置的距离，单位公里）<br/>
       3.初始显示已绑定的服务者接单区域，若要添加或修改服务者区域，可选择加载地图区域后再操作，最后点击下面保存按钮
      </p>
      <el-table :data="dataList" border fit highlight-current-row max-height="400">
        <el-table-column align="center" label="id" prop="id" />
        <el-table-column align="center" label="城市" prop="cityName" />

        <el-table-column align="center" label="区域名称" prop="areaName" />
        <el-table-column align="center" label="服务区域距离" prop="distanceMetre">
          <template slot-scope="scope"> {{ scope.row.distanceMetre }}km</template>
        </el-table-column>
        <el-table-column align="center" label="中心点" prop="center" />
        <el-table-column prop="state" label="优先级排序" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-upload2" @click="topArea(scope.row, scope.$index)"
              v-if="scope.$index != 0">置顶</el-button>
          </template>
        </el-table-column>
      </el-table>


      <!-- 地图展示 -->
      <div class="map-wrapper">
        <div id="mapContainer" style="height:400px;width:860px;"></div>
      </div>




      <span slot="footer" class="dialog-footer">
        <el-button @click="areaVisible = false">取 消</el-button>
        <el-button type="primary" @click="comfirmAreaBtn('workerAreaForm')">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";
import Pagination from "@/components/common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import service from "@/script/api/service";
import workercrmapi from "@/script/api/workercrmapi";
import globalData from "@/components/common/globaldata/global.data.vue";
let vm;
export default {
  data() {
    return {
      showType: true,
      map: '',
      mapText: [],
      workerInfo: {
        workerName: ""
      },
      areaVisible: false,
      areaList: [],

      levelOneName:[],
      countyList:[],
      workerAreaForm: {
        area: []
      },
      areaRules: {
        // area: [
        //   {
        //     required: true,
        //     message: "请选择接单区域",
        //     trigger: "change"
        //   }
        // ]
      },
      dataList: [],

      workerSubState: {
        1: "背调失败",
        2: "培训淘汰",
        3: "拒绝入职",
        4: "入职审批拒绝"
      },
      type: null, //操作类型： type 1解约原因，2流失原因
      subType: null, //线索4跟进失败  服务者5上线失败
      chooseSubType: "",
      levelOneList: [],
      optionProps: {
        value: "type",
        label: "typeValue",
        children: "childList",
        multiple: true
        //  checkStrictly: true
      },

      tempRow: {},

      refuseRules: {
        levelOne: [
          {
            required: true,
            message: "请选择原因",
            trigger: "change"
          }
        ]
      }
    };
  },
  beforeCreate() {
    vm = this;
  },
  methods: {
    init(row) {
      let that = this;
      console.log(row);
      this.areaVisible = true;
      this.workerInfo = row;
      this.workerAreaForm.area = [];
      this.dataList = [];
      this.$nextTick(() => {
        this.map = new AMap.Map("mapContainer", {
          resizeEnable: true,
          // center: [116.397428, 39.90923], //地图中心点
          zoom: 16, //地图显示的缩放级别
          keyboardEnable: false
        });
        //    this.map.on("complete", function(){
        //    console.log("地图加载完成！");  
        that.map.clearMap();


        if (row.serviceLngLat) {
          //  let marker = new AMap.Marker({
          //     position: new AMap.LngLat(row.serviceLngLat.split(',')[0], row.serviceLngLat.split(',')[1]),
          //     content: "<div style='background:red;width:80px;height:30px;font-size:20px'>服务者</div>",
          //     raiseOnDrag: true
          //   });
          //   this.map.add(marker);
          //    this.map.setFitView([marker]);
          let marker = new AMap.Marker({
            icon: "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
            position: [row.serviceLngLat.split(',')[0], row.serviceLngLat.split(',')[1]],
            offset: new AMap.Pixel(-13, -30)
          });

          that.map.add(marker);
          that.map.setFitView();

        }


        // workercrmapi
        //   .$ajaxGetCityNoCutRange({
        //     cityId: row.cityId,
        //     lngLat: row.serviceLngLat
        //   })
        //   .then(res => {
        //     that.areaList = res.data.data;
        //     that.getWorkerArea();
        //   });
        that.getWorkerArea();
        that.getcountyList(row.cityId); 
        
        // });

      });
 
   


    },
    getCityArea(){
      if(this.levelOneName==null||this.levelOneName.length==0){
        this.$message.warning("请选择要加载的区域");
        return;
      }
       workercrmapi
          .$ajaxGetCityNoCutRange({
            cityId: this.workerInfo.cityId,
            lngLat: this.workerInfo.serviceLngLat, 
            levelOneName:this.levelOneName
          })
          .then(res => {
            this.areaList = res.data.data;
           let t=res.data.data.concat(this.dataList);
          
           this.areaList =t;
            this.getMapArea(this.workerAreaForm.area);
          });
    },
    getcountyList(cityId){
      if(cityId==null||cityId==''){
        this.countyList=[];
        return;
      }
      //区县
      workercrmapi
        .$ajaxGetCityLevelOne({cityId:cityId})
        .then(res => {
          if (res.data.errno == 0) {
            this.countyList=res.data.data; 
            this.levelOneName=[];
          }  
        })
    },
    getWorkerArea() {
      workercrmapi
        .$ajaxGetWorkerAreaId({
          workerId: this.workerInfo.id
        })
        .then(res => {
          let area = res.data.data.workerAreaIds; 
          this.areaList = res.data.data.workerAreaList;

          this.workerAreaForm.area = area;
          this.areaChange(area);
          this.getMapArea(area);
        });
    },
    areaChange(value) {
      console.log(value);
      let area = value;
      let tableList = [];
      area.forEach(item => {
        let obj = this.areaList.filter(item1 => {
          return item == item1.id;
        });
        if (obj.length > 0) {
          tableList.push(obj[0]);
        }
      });
      this.dataList = tableList;
    },
    getMapArea(value) {
      this.map.clearMap();
      let that = this;
      let mapArea = [];
      let areaId = value;
      that.mapText = [];

      areaId.forEach(item => {
        let obj = this.areaList.filter(item1 => {
          if (item == item1.id) {
            item1.isChoose = 1; //标记被选中的
          }
          return item == item1.id;
        });

        if (obj.length > 0) {
          mapArea.push(obj[0]);
        }

      });
      //  console.log(mapArea);
      //console.log(this.areaList);
      var infoWindow = new AMap.InfoWindow({
        offset: new AMap.Pixel(0, 0)
      });
      //  mapArea.forEach(item => {
      this.areaList.forEach(item => { //
        let area = item.area;
        area = area.split("|");
        area = area.map(item1 => {
          return item1.split(",");
        });
        // console.log(area);
        // let fillColor = item.level == 1 ? "#1791fc" : "#09af11";
        // let zIndex = item.level == 1 ? 50 : 100;
        let fillColor = item.isChoose == 1 ? "#FF33FF" : "#09af11";
        let zIndex = item.isChoose == 1 ? 100 : 50;
        let polygon = new AMap.Polygon({
          path: area,
          strokeColor: "#09af11",
          strokeWeight: 6,
          strokeOpacity: 0.2,
          fillOpacity: 0.4,
          fillColor: fillColor,
          zIndex: zIndex
        });

        that.map.add(polygon);
        let center = item.center.split(",");
        var text = new AMap.Text({
          text: item.areaName,
          anchor: "center", // 设置文本标记锚点
          draggable: true,
          cursor: "pointer",
          angle: 10,
          style: {
            padding: "2px 4px",
            "margin-bottom": "2px",
            "border-radius": "4px",
            "background-color": "white",
            width: "auto",
            "border-width": 0,
            "box-shadow": "0 2px 6px 0 rgba(114, 124, 245, .5)",
            "text-align": "center",
            "font-size": "14px",
            color: "blue"
          },
          position: center
        });
        //缓存
        that.mapText.push({ text: text, isChoose: item.isChoose == 1 });

        if (that.showType && item.isChoose == 1)
          text.setMap(that.map);

        polygon.on("mouseover", function (e) {
          polygon.setOptions({
            fillOpacity: 0.7
          });
          infoWindow.setContent(
            "<br>区域级别:" + (item.level == 1 ? '一级' : '二级') +
            "<br>区域名称:" + item.areaName +
            "<br>服务者数量:" + item.countWorker +
            "<br>库存利用率:" + item.stockAvailability
          );
          infoWindow.open(that.map, center);
          setTimeout(() => {
            infoWindow.close();
          }, 2000);
        });
        polygon.on("mouseout", function (e) {
          polygon.setOptions({
            fillOpacity: 0.4
          });
          infoWindow.close();
        });


        //创建右键菜单
        var contextMenu = new AMap.ContextMenu();
        contextMenu.addItem("【-解绑】" + item.areaName + "-" + item.id, function () {
          const itemId = this.innerText.substring(this.innerText.lastIndexOf('-') + 1);
          that.workerAreaForm.area = that.workerAreaForm.area.filter(item => item != parseInt(itemId));
          if (that.showType)
            text.setMap('')
          that.areaChange(that.workerAreaForm.area);
        }, 0);

        contextMenu.addItem("【+绑定】" + item.areaName + "-" + item.id, function () {
          const itemId = this.innerText.substring(this.innerText.lastIndexOf('-') + 1);
          if (that.workerAreaForm.area.some(item => item == parseInt(itemId))) return;
          that.workerAreaForm.area.push(parseInt(itemId));
          that.areaChange(that.workerAreaForm.area); 
          text.setMap(that.map)
        }, 1);

        //地图绑定鼠标右击事件——弹出右键菜单
        polygon.on('rightclick', function (e) {
          contextMenu.open(that.map, e.lnglat);
        });

      });
      this.map.setFitView();
    },
    topArea(row, index) {
      console.log(index);
      if (index != 0) {
        let list = this.dataList;
        list.splice(index, 1);
        list.unshift(row);
        this.dataList = list;
      }
    },
    comfirmAreaBtn(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let areaId = this.dataList.map(item => {
            return item.id;
          });
          console.log(areaId);

          workercrmapi
            .$ajaxBindWorkerArea({
              areaId: areaId,
              cityId: this.workerInfo.cityId,
              workerId: this.workerInfo.id,
              operUserId: globalData.userInfo.id
            })
            .then(res => {
              this.areaVisible = false;
              this.$message.success("操作成功");
              this.$parent.querySearch();
              console.log(res);
            })
            .catch(err => {
              console.log(err);
            });
        } else {
          console.log("err");
        }
      });
    },
    showTypeChange() {
      this.mapText.forEach(item => {
        if (!this.showType)
          item.text.setMap(this.map);
        else if (item.isChoose == false)
          item.text.setMap('');
      })
    }
  }
};
</script>
<style scoped>
>>>.el-select {
  width: 500px !important;
}

#mapContainer {
  margin-top: 20px;
  width: 100%;
  height: 400px;
  line-height: 1.5;
  font-weight: 300;
  color: #111213;
  font-size: 12px;
}
</style>
<style>
.context_menu {
  position: relative;
  min-width: 12rem;
  padding: 0;
  background-color: aliceblue;
}

.context_menu p {
  cursor: pointer;
  padding: 0.25rem 1.25rem;
}

.context_menu p:hover {
  background: #ccc;
}
</style>
